import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("yatto_cart") || "[]");
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem("yatto_cart", JSON.stringify(items));
    }, [items]);

    const addItem = useCallback((product, cases) => {
        setItems((prev) => {
            const existing = prev.find((i) => i.product_id === product.id);
            if (existing) {
                return prev.map((i) =>
                    i.product_id === product.id ? { ...i, cases: i.cases + cases } : i
                );
            }
            return [
                ...prev,
                {
                    product_id: product.id,
                    name: product.name,
                    brand: product.brand,
                    unit_size: product.unit_size,
                    units_per_case: product.units_per_case,
                    image: product.image,
                    wholesale_price_per_case: product.wholesale_price_per_case,
                    cases,
                    note: "",
                },
            ];
        });
    }, []);

    const updateNote = useCallback((productId, note) => {
        setItems((prev) => prev.map((i) => (i.product_id === productId ? { ...i, note } : i)));
    }, []);

    const updateCases = useCallback((productId, cases) => {
        setItems((prev) =>
            prev.map((i) => (i.product_id === productId ? { ...i, cases: Math.max(1, cases) } : i))
        );
    }, []);

    const removeItem = useCallback((productId) => {
        setItems((prev) => prev.filter((i) => i.product_id !== productId));
    }, []);

    const clear = useCallback(() => setItems([]), []);

    const count = items.reduce((s, i) => s + i.cases, 0);

    const value = useMemo(
        () => ({ items, addItem, updateCases, updateNote, removeItem, clear, count }),
        [items, addItem, updateCases, updateNote, removeItem, clear, count]
    );

    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
